class PersistedStore {
  constructor(prefix) {
    this.prefix = prefix;
  }

  async setItem(name, values) {
    const key = `${this.prefix}${name}`;
    global.localStorage.setItem(key, JSON.stringify(values));
  }

  async getItem(name) {
    const key = `${this.prefix}${name}`;
    const raw = global.localStorage.getItem(key);
    if (raw) {
      return JSON.parse(raw);
    }
    return undefined;
  }

  async removeItem(name) {
    const key = `${this.prefix}${name}`;
    global.localStorage.removeItem(key);
  }

  async clear() {
    Object.keys(global.localStorage)
      .filter((key) => key.startsWith(this.prefix))
      .forEach((key) => {
        global.sessionStorage.removeItem(key);
      });
  }
}

export default new PersistedStore('_persisted_');
